import React from "react";
import PaymentRequestButton from "./PaymentRequestButton";

const GooglePayButton = (props) => {
  return <PaymentRequestButton {...props} provider="google" />;
};

export default GooglePayButton;